import { useState } from 'react';
import { Input } from './ui/input'
import { FaTrash, FaUpload } from 'react-icons/fa';
import { Separator } from './ui/separator';
import { DialogClose } from './ui/dialog';
import useSettingsStore from '@/store/SettingsStore';

function ImageUploader({ setPreviewWallpaper, previewWallpaper }: { setPreviewWallpaper: ((previewWallpaper: string | null) => void), previewWallpaper: string | null }) {
  const [isDragging, setIsDragging] = useState(false);
  const setBackgroundImage = useSettingsStore(state => state.setBackgroundImage)
  const addCustomWall = useSettingsStore(state => state.addCustomWall)

  const handleFiles = (files: FileList | null) => {
    if (files && files[0] && files[0].type.startsWith('image/')) {
      setPreviewWallpaper(URL.createObjectURL(files[0]))
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    handleFiles(e.dataTransfer.files);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleFiles(e.target.files);
  };

  const handleRemoveImage = () => {
    setPreviewWallpaper(null);
  };

  return (
    <>
      <Input value={previewWallpaper ?? ""} onChange={(e) => setPreviewWallpaper(e.target.value)} placeholder="Paste an image link" />
      <div className="flex justify-center items-center space-x-4"><Separator className="shrink bg-zinc-300 dark:bg-zinc-800" /><span>or</span><Separator className="shrink bg-zinc-300 dark:bg-zinc-800" /></div>
      <div className="flex flex-col items-center w-full max-w-md mx-auto">
        <div
          className={`w-full flex items-center justify-center border-2 ${isDragging ? "border-red-500" : "border-zinc-700"} border-dashed rounded-md text-zinc-900 bg-zinc-100 dark:bg-zinc-900 dark:text-white`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          {previewWallpaper ? (
            <div className="text-center relative w-full h-60 overflow-hidden">
              <img
                src={previewWallpaper}
                alt="Preview"
                className="h-full w-full object-cover rounded-md mx-auto"
              />
              <button
                onClick={handleRemoveImage}
                className="absolute top-1 right-1 inline-flex items-center gap-2 bg-red-500/70 text-white p-2 rounded hover:bg-red-500"
              >
                <FaTrash />
              </button>
            </div>
          ) : (
            <div className="text-center flex flex-col justify-center items-center h-60 w-full">
              <FaUpload size={32} className="mx-auto mb-3" />
              <p className="text-sm text-zinc-600 dark:text-zinc-400">
                Drag & drop your image here, or click to select
              </p>
              <input
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleInputChange}
                id="single-file-upload"
              />
              <label
                htmlFor="single-file-upload"
                className="mt-3 inline-block bg-zinc-700 text-zinc-200 dark:bg-zinc-300 dark:text-zinc-800 px-4 py-2 rounded cursor-pointer hover:bg-zinc-400"
              >
                Browse File
              </label>
            </div>
          )}
        </div>
      </div>
      <div className="flex justify-center items-center px-2">
        <DialogClose
          onClick={() => {
            if (previewWallpaper) {
              setBackgroundImage(previewWallpaper)
              addCustomWall(previewWallpaper)
            }
          }}
          disabled={!previewWallpaper}
          className="w-full py-2 px-4 rounded font-semibold bg-zinc-200/80 hover:bg-zinc-300/80 disabled:bg-zinc-200/50 disabled:hover:bg-zinc-200/50 disabled:text-zinc-600 text-black dark:bg-zinc-800/80 dark:hover:bg-zinc-700/80 dark:disabled:bg-zinc-800/50 dark:disabled:hover:bg-zinc-800/50 dark:disabled:text-zinc-400 dark:text-white"
        >
          Add wallpaper
        </DialogClose>
      </div>
    </>
  )
}

export default ImageUploader